<template>
  <div class="nxCollapse">
    <div
      class="nx-collapse-item"
      v-for="(item, index) in 4"
      :key="index"
      :class="{ collapse_active: active_index == index }"
      @mouseover="collapse_item_click(index)"
    >
      <div class="title ellipsis" :class="{ title_active: active_index == index }">
        某人在10年前向我借款10万，利息约定为年利息1.8万，当时为口头约定如果这种情况要....
      </div>
      <div class="content">
        <div class="content_text">
          请问某人在10年前向我借款10万，利息约定为年利息1.8万，当时为口头约定，后续利息未支付，中间在
          16年跟20年之间还清10万欠款本金，在2020年底给了2万利息便不再给，从头到尾没有打欠条，当初...
        </div>
        <div class="cont_bottom between">
          <div class="bottom_le flex_start">
            <div>
              <img src="~assets/base/small_rentou.png" />
              <img src="~assets/base/small_rentou.png" class="m_15" />
              <img src="~assets/base/small_rentou.png" class="m_15" />
            </div>
            <div><span>3</span>位律师回复</div>
          </div>
          <div>10分钟前</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active_index: 0,
    };
  },
  methods: {
    collapse_item_click(index) {
      this.active_index = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.nxCollapse {
  .nx-collapse-item {
    padding: 22px 0;
    border-bottom: 1px solid #eee;
    &:last-child{
    border-bottom: none;
    }
    .title {
      font-size: 16px;
      color: #666666;
    }
    .title_active {
      color: #0465ea;
    }
    .content {
      height: 0;
      overflow: hidden;
      transition: all 0.1s;
      .content_text {
        margin-top: 15px;
        margin-bottom: 22px;
        font-size: 14px;
        color: #999999;
      }
      .cont_bottom {
        color: #999999;
        .bottom_le {
          font-size: 14px;
          .m_15 {
            margin-left: -15px;
          }
          span {
            color: #0465ea;
            margin-left: 10px;
          }
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
  .collapse_active {
    .content {
      height: 135px;
    }
  }
}
</style>